
export const ABOUT_US_LINK = "/aboutUs";
export const CONVERTOR_HOME_PAGE_LINK = "/convertorHomePage";
export const COMPRESSOR_HOME_PAGE_LINK = "/compressorHomePage";
export const CONVERTOR_FORM_PAGE_LINK = "/convertorFormPage";
export const COMPRESSOR_FORM_PAGE_LINK = "/compressorFormPage";